import { Modal } from "@material-ui/core";
import React from "react";
import { connect } from "react-redux";
import { compose } from "recompose";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { closeChooseCountryModal } from "../../reducers/general/actions";
import useStyles from "./styles";
// import { listCountryPayment } from "../../static/static-data/payment/static_payment_data";
import { setCookiePayment } from "../../helpers/setCookie";

function ChooseCountryModal({ t, countryModal }) {
  const classes = useStyles();

  const onCloseModal = () => {
    closeChooseCountryModal();
  };

  const handleSelectCountry = (key) => {
    if (countryModal.onPressCallback) {
      countryModal.onPressCallback(key);
    }
    setCookiePayment(key);
    setTimeout(() => {
      setCookiePayment(key);
      setTimeout(() => {
        setCookiePayment(key);
        setTimeout(() => {
          setCookiePayment(key);
          setTimeout(() => {
            setCookiePayment(key);
          }, 500);
        }, 500);
      }, 500);
    }, 500);
    closeChooseCountryModal();
  };

  // function renderListCountry() {
  //   return (
  //     <div className={classes.ctnCountry}>
  //       {listCountryPayment.map((country) => (
  //         <div
  //           className={classes.ctnCountryItem}
  //           key={country.key}
  //           onClick={() => {
  //             handleSelectCountry(country.key);
  //           }}
  //         >
  //           <img src={country.source} alt={country.key} />
  //           <span>{country.key === "SG" ? t("singapore") : country.title}</span>
  //         </div>
  //       ))}
  //     </div>
  //   );
  // }

  return (
    <Modal
      open={countryModal.visible}
      onClose={onCloseModal}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      className={classes.rootContainer}
    >
      <div className={classes.ctnModal}>
        <div id="padding-content">
          <span id="title">{t("choose-country")}</span>
          {/* {renderListCountry()} */}
        </div>
      </div>
    </Modal>
  );
}

ChooseCountryModal.propTypes = {
  t: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  countryModal: state.generalReducer.countryModal,
});

const enhancer = compose(
  withTranslation(["myfitsociety"]),
  connect(mapStateToProps),
);

export default enhancer(ChooseCountryModal);
